import PropTypes from 'prop-types';
import React from 'react';

const Tag = ({ children, color, backgroundColor, className }) => (
  <div
    style={{ background: backgroundColor }}
    className={`tag ${color} ${className}`}
  >
    {children === 0 || children ? children : '-'}
  </div>
);

Tag.propTypes = {
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
};

Tag.defaultProps = {
  children: null,
  backgroundColor: '#aaaaaa',
  color: '',
  className: '',
};

export default Tag;
